export const trackSelectPlanEvent = () => {
  return {
    event: 'planCard.selectPlan',
    w3cddl: {
      event: [
        {
          eventInfo: {
            eventName: 'Select Plan',
            eventAction: 'planCard.selectPlan',
          },
        },
      ],
    },
  };
};

export const trackChangePlanEvent = () => {
  return {
    event: 'planCard.changePlan',
    w3cddl: {
      event: [
        {
          eventInfo: {
            eventName: 'Change Plan',
            eventAction: 'planCard.changePlan',
          },
        },
      ],
    },
  };
};

export const trackModalWindowViewEvent = (eventName: string) => {
  return {
    event: 'modalWindow.view',
    w3cddl: {
      event: [
        {
          eventInfo: {
            eventName,
            eventAction: 'modalWindow.view',
          },
        },
      ],
    },
  };
};
